import { Athlete } from "./athlete";

interface CommunicationData {
  id?: number;
  athleteId?: number;
  writer?: number;
  message?: string;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;

  athlete?: Athlete;
}


export class Communication {
  public static readonly WRITTEN_BY_ATHLETE: number = 0;
  public static readonly WRITTEN_BY_COACH: number = 1;

  public static getNonTranslatableFields(): string[] { return ['id', 'athleteId', 'writer', 'message', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getTranslatableFields(): string[] { return []; }
  public static getFields(): string[] { return ['id', 'athleteId', 'writer', 'message', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getKeyFields(): string[] { return ['id']; }

  id?: number;
  athleteId?: number;
  writer?: number;
  message?: string;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;

  athlete?: Athlete;

  public static fromAPI(data: CommunicationData): Communication {
    return new Communication(data);
  }

  public static fromAPIList(data: CommunicationData[]): Communication[] {
    return data.map((item: CommunicationData) => Communication.fromAPI(item));
  }

  constructor({id, athleteId, writer, message, createDate, createrId, updateDate, updaterId, deleteDate, deleterId,
              athlete}: CommunicationData) {
    this.id = id;
    this.athleteId = athleteId;
    this.writer = writer;
    this.message = message;
    this.createDate = createDate;
    this.createrId = createrId;
    this.updateDate = updateDate;
    this.updaterId = updaterId;
    this.deleteDate = deleteDate;
    this.deleterId = deleterId;

    this.athlete = athlete;
  }

  public toJson(): CommunicationData {
    return {
      id: this.id,
      athleteId: this.athleteId,
      writer: this.writer,
      message: this.message,
      createDate: this.createDate,
      createrId: this.createrId,
      updateDate: this.updateDate,
      updaterId: this.updaterId,
      deleteDate: this.deleteDate,
      deleterId: this.deleterId
    };
  }

}
